







import Vue, { PropType } from "vue";
import dayjs from "dayjs";

interface Props {
  /** Megjelenítendő dátum / időpont (Date vagy string) */
  value: string | Date | null | undefined;
  /** Dátum dayjs formátum — default: `YYYY.MM.DD` */
  dateFormat: string;
  /** Idő dayjs formátum — default: `HH:mm` (lehet pl. `HH:mm:ss`) */
  timeFormat: string;
}

interface Computed {
  formattedDate: string;
  formattedTime: string;
}

export default Vue.extend<{}, {}, Computed, Props>({

  props: {
    value: {
      type: [String, Date] as PropType<string | Date | null | undefined>,
      default: null,
    },
    dateFormat: { type: String, default: "YYYY.MM.DD" },
    timeFormat: { type: String, default: "HH:mm" },
  },

  computed: {
    formattedDate(): string {
      if (!this.value) return "";
      return dayjs(this.value as any).format(this.dateFormat);
    },
    formattedTime(): string {
      if (!this.value) return "";
      return dayjs(this.value as any).format(this.timeFormat);
    },
  },
});
